import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Spinner from '../audi-ui-components/Spinner';

const Loading = (props) => {
  return (
    <div className={classnames("loader", props.type)}>
      <div className="loader__inner">
        <Spinner isContinuous />
        {props.children && <div>{props.children}</div>}
      </div>
    </div>
  );
}

Loading.propTypes = {
  type: PropTypes.oneOf(['overlay', 'placeholder'])
};

Loading.defaultProps = {
  type: 'placeholder'
};

export default Loading;
